<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Moje Konto - LOGOWANIE</div>
          <div class="card-body text-center">
            <a :href="webLink" target="_blank">
              <img class="p-3" :src="logoSrc" alt="skp"
            /></a>
            <form action="#" method="POST" @submit.prevent="login">
              <div class="form-group row">
                <label
                  for="userable_id"
                  class="col-md-4 col-form-label text-md-right"
                  >Numer licencji</label
                >
                <div class="col-md-5">
                  <input
                    id="userable_id"
                    type="number"
                    class="form-control"
                    name="userable_id"
                    required
                    autocomplete="userable_id"
                    autofocus
                    v-model="form.userable_id"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="password"
                  class="col-md-4 col-form-label text-md-right"
                  >Hasło</label
                >
                <div class="col-md-5">
                  <input
                    id="password"
                    type="password"
                    class="form-control"
                    name="password"
                    required
                    autocomplete="current-password"
                    v-model="form.password"
                  />
                </div>
              </div>
              <p v-if="errors.length" class="error offset-md-2"></p>
              <ul>
                <li
                  v-for="error in errors"
                  v-bind:key="error"
                  class="text-danger"
                >
                  {{ error }}
                </li>
              </ul>
              <div class="form-group row mb-10">
                <div class="col-md-8 offset-md-1">
                  <button type="button" class="btn btn-link ml-4">
                    <router-link
                      :to="{
                        name: 'ChangePassword',
                        props: { program: program },
                      }"
                      >Nie pamiętam hasła</router-link
                    >
                  </button>
                </div>
              </div>
              <div class="text-danger small mb-2">
                Uwaga! Przed pierwszym logowaniem, ZAREJESTRUJ SIĘ do Serwisu
                Moje Konto wybierając opcję na dole "Zarejestruj się".
              </div>
              <div class="form-group row mb-10 justify-content-md-center">
                <div class="col-md-6">
                  <button type="submit" class="btn btn-success btn-block">
                    Zaloguj
                  </button>
                </div>
              </div>
              <div class="form-group row mb-0 justify-content-md-center my-3">
                <div class="col-md-6 h5">
                  Nie masz konta?
                  <router-link
                    :to="{ name: 'Register', props: { program: program } }"
                    >Zarejestruj się</router-link
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  props: {
    logoSrc: {},
  },
  data() {
    return {
      form: {
        userable_id: '',
        password: '',
        program: '',
      },
      errors: [],
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
    }),
    webLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/'
        : 'https://www.samozatrudnienie.pl/';
    },
  },
  beforeCreate: function () {
    document.body.className = 'login';
  },
  methods: {
    ...mapActions({
      signIn: 'auth/signIn',
    }),

    async login() {
      this.form.program = this.program;
      try {
        await this.signIn(this.form);

        this.$router.push({
          name: 'Licence',
          params: { program: this.program },
        });
      } catch (error) {
        this.errors.push('Nieprawidłowe dane użytkownika.');
      }
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
